import { render, staticRenderFns } from "./phoneNum.vue?vue&type=template&id=285fcc22&scoped=true"
import script from "./phoneNum.vue?vue&type=script&lang=js"
export * from "./phoneNum.vue?vue&type=script&lang=js"
import style0 from "./phoneNum.vue?vue&type=style&index=0&id=285fcc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285fcc22",
  null
  
)

export default component.exports